import React from "react";
import { StyleSheet, View, Canvas, Text } from "@react-pdf/renderer";
import generalStyle from "../GeneralStyles";

export const Body = ({ themeData, title, children }) => {
  const bodyBlock = StyleSheet.create({
    bodyBlockWrapper: {
      borderRadius: 5,
      backgroundColor: "white",
      padding: "18 16 9",
      margin: "70 27 15",
      flex: 1,
    },
    bodyTitle: {
      fontSize: 18,
      ...generalStyle.semiBold,
    },
    gradientBar: {
      width: 44,
      height: 4,
      backgroundColor: themeData.secondary,
    },
  });

  return (
    <View data-testid="body-block" style={bodyBlock.bodyBlockWrapper}>
      <View style={bodyBlock.bodyTitle}>
        <Text>{title}</Text>
        <Canvas style={bodyBlock.gradientBar} />
      </View>
      {children}
    </View>
  );
};
